var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"80vh"}},[_c('van-empty',{attrs:{"image":"error","description":"找不到信息"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }